module.exports = __webpack_public_path__ + "img/deuterium-formula.27d34991.png";